<template>
  <el-dialog width="800px" :visible.sync="isVisible" :title="title" :close-on-click-modal="false">
    <el-form ref="elForm" :model="form" :rules="rules" label-width="80px" style="margin: auto;width: 520px;">
      <el-form-item label="科类" prop="majorType" v-show="!currentStudent.major">
        <el-select v-model="form.majorType" placeholder="请选择科类" style="width: 260px;" @change="setFormName()">
          <el-option label="物理" :value="1"></el-option>
          <el-option label="历史" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-row type="flex">
        <el-form-item label="分数" prop="score" clearable>
          <el-input @input="onInputScore" :readonly="form.readOnly" v-model="form.score" maxlength="6" placeholder="请输入分数" clearable></el-input>
        </el-form-item>
        <el-form-item label="位次" prop="precedence" >
          <el-row type="flex" align="middle">
            <el-input @input="onInputPrecedence" :readonly="form.readOnly" v-model="form.precedence" placeholder="请输入位次" maxlength="10" clearable></el-input>
<!--            <i class="el-icon-warning-outline icon-precedence" @click="onClickShowPrecedenceDialog"></i>-->
            <img width="25" height="25" src="~@/assets/images/icon-weici.jpg" alt="weici" style="margin-left: 10px;vertical-align:middle;margin-top: -2px;cursor: pointer" @click="onClickShowPrecedenceDialog">
          </el-row>
        </el-form-item>
      </el-row>
      <el-form-item label="批次" prop="region">
        <el-select v-model="form.region" placeholder="请选择" style="width: 260px;" @change="setFormName()">
          <el-option label="本科提前批单设" value="本科提前批单设"></el-option>
          <el-option label="本科提前批平行" value="本科提前批平行"></el-option>
          <el-option label="本科普通批平行" value="本科普通批平行"></el-option>
          <el-option label="高职专科提前批" value="高职专科提前批"></el-option>
          <el-option label="高职专科普通批" value="高职专科普通批"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.region === '本科提前批单设' || form.region === '本科提前批平行' || form.region === '高职专科提前批'" label="*类别" prop="schemeRecruitType">
        <el-select v-if="form.region === '本科提前批单设'" v-model="form.recruitType" placeholder="请选择类别" style="width: 260px;" @change="setFormName()">
          <el-option label="军校招飞" value="军校招飞"></el-option>
        </el-select>
        <el-select v-if="form.region === '本科提前批平行'" v-model="form.recruitType" placeholder="请选择类别" style="width: 260px;" @change="setFormName()">
          <el-option label="军队院校" value="军队院校"></el-option>
          <el-option label="公安院校" value="公安院校"></el-option>
          <el-option label="其他院校" value="其他院校"></el-option>
          <el-option label="特殊院校" value="特殊院校"></el-option>
        </el-select>
        <el-select v-if="form.region === '高职专科提前批'" v-model="form.recruitType" placeholder="请选择类别" style="width: 260px;" @change="setFormName()">
<!--          <el-option label="公安院校" value="公安院校"></el-option>-->
          <el-option label="定向军士" value="定向军士"></el-option>
          <el-option label="航海专业" value="航海专业"></el-option>
          <el-option label="订单医学生" value="订单医学生"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveScheme()" v-loading.fullscreen.lock="fullscreenLoading">立即创建</el-button>
      </el-form-item>
    </el-form>

    <ChartDialog title="位次查询"
      ref="chartDialog" append-to-body
      :dialog-visible.sync="precedenceDialog.open"
    />
  </el-dialog>
</template>
<script>
import { request } from "@/util/request.js"
import { miniThrottle } from '@/util'
import ChartDialog from "@/components/ChartDialog"

export default {
  inheritAttrs: false,
  components: { ChartDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      precedenceDialog: {
        open: false,
      },
      fullscreenLoading: false,
      currentStudent: {},
      form: this.initForm(),
      rules: {
        majorType: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        region: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        score: [
          { required: true, message: '请输入分数', trigger: 'change' },
          { pattern: /^[1-9]\d*$/, message: '请输入大于0的整数', trigger: 'change' },
        ],
        precedence: [
          { required: true, message: '请输入位次', trigger: 'change' },
          { pattern: /^[1-9]\d*$/, message: '请输入大于0的整数', trigger: 'change' },
        ],
      },
      tqdsRecruitTypeList: ['军校招飞'],
      tqpxRecruitTypeList: ['军队院校', '公安院校', '其他院校', '特殊院校'],
      ptdsRecruitTypeList: ['高校专项'],
      gztqRecruitTypeList: ['定向军士', '航海专业', '订单医学生'],
    }
  },
  computed: {
    // 弹窗是否可见
    isVisible: {
      get() {
        return this.dialogVisible
      },
      set() {
        this.close()
        this.reset()
      }
    },
  },
  watch: {},
  created() {

  },
  mounted() {

  },
  methods: {
    // 新建方案-科类
    setFormName() {
      setTimeout(()=>{   //设置延迟执行
        if (this.form.region === '本科提前批单设') {
          this.form.recruitType = '军校招飞';
        } else if (this.form.region === '本科提前批平行') {
          if(!this.tqpxRecruitTypeList.includes(this.form.recruitType)){
            this.form.recruitType = '军队院校';
          }
        } else if (this.form.region === '高职专科提前批') {
          if(!this.gztqRecruitTypeList.includes(this.form.recruitType)){
            this.form.recruitType = '定向军士';
          }
        } else if (this.form.region === '本科普通批平行' || this.form.region === '高职专科普通批') {
          this.form.recruitType = '';
        }
      },100);
    },
    onClickShowPrecedenceDialog() {
      this.$refs['elForm'].validateField('score', (errMsg) => {
        if(this.form.score != null){
          let regGT100LT700 = /^([1-6][0-9]{2})$/
          if (!regGT100LT700.test(this.form.score)) {
            return this.$message.error('请输入100-700分数区间')
          }
          this.$refs.chartDialog.setData(this.form.score)
          this.precedenceDialog.open = true;
        }else{
          this.$refs.chartDialog.setData(580)
          this.precedenceDialog.open = true;
        }
      })
      var userInfo = JSON.parse(localStorage.getItem("stu"));
      this.$refs.chartDialog.setType(userInfo.major)
    },
    onInputScore() {
      if(!this.form.readOnly){
        miniThrottle(this.getPrecedenceByScore, 500)
      }
    },

    onInputPrecedence() {
      if(!this.form.readOnly){
        miniThrottle(this.getScoreByPrecedence, 500)
      }
    },

    // 通过分数自动输入位次
    getPrecedenceByScore() {
      if (!this.form.score) {
        this.form.precedence = ''
        return
      }
      if (this.form.score.length < 3) {
        return
      }
      this.$refs['elForm'].validateField('score', (errMsg) => {
        if (errMsg !== '') return
        request({
          method: 'get',
          url: '/score/line/getPrecedence',
          params: {
            "type": this.currentStudent.major || this.form.majorType,
            "score": this.form.score,
          }
        }).then(res => {
          if (![0, 200].includes(res.code)) {
            this.form.precedence = ''
            return this.$message.error(res.msg);
          }
          this.form.precedence = res.data
        })
      })
    },
    // 通过位次自动输入分数
    getScoreByPrecedence() {
      if (!this.form.precedence) {
        this.form.precedence = ''
        return
      }
      this.$refs['elForm'].validateField('precedence', (errMsg) => {
        if (errMsg !== '') return
        request({
          method: 'get',
          url: '/score/line/getScoreByParam',
          params: {
            "type": this.currentStudent.major || this.form.majorType,
            "precedence": this.form.precedence,
          }
        }).then(res => {
          if (![0, 200].includes(res.code)) {
            this.form.score = ''
            return this.$message.error(res.msg);
          }
          this.form.score = res.data
        })
      })
    },
    close() {
      this.$emit('update:dialogVisible', false)
    },

    reset() {
      this.currentStudent = {}
      this.$refs['elForm'].clearValidate()
      this.$refs['elForm'].resetFields()
      this.form = this.initForm();
    },

    setData(currentStudent) {
      this.currentStudent = currentStudent;
      if(this.currentStudent.disabledScore){
        this.form.score = this.currentStudent.score;
        this.form.precedence = this.currentStudent.precedence;
        this.form.readOnly = true;
      }
    },

    initForm() {
      return {
        majorType: 1,
        name: '理工本科普通批平行',
        region: '本科普通批平行',
        score: undefined,
        precedence: undefined,
        recruitType: '',
        readOnly: false,
      }
    },
    saveScheme() {
      if (this.currentStudent.major) {
        this.form.majorType = this.currentStudent.major
      }
      this.$refs['elForm'].validate(valid => {
        if (!valid) return
        this.fullscreenLoading = true;
        request({
          method: 'post',
          url: 'stuSchemeV2/saveScheme',
          data: [{
            "score": this.form.score,
            "precedence": this.form.precedence,
            "majorType": this.form.majorType,
            "batch": this.form.region,
            "recruitType": this.form.recruitType,
            "stuId": this.currentStudent.id,
            "subject1": this.currentStudent.subject1,
            "subject2": this.currentStudent.subject2,
          }]
        }).then(res => {
          if (![0, 200].includes(res.code)) {
            return this.$message.error(res.msg);
          }
          this.$message.success('保存成功！');
          this.$emit('submitted', res)
          this.isVisible = false
          this.fullscreenLoading = false;
        })
      })
    },
  }
}

</script>
<style lang="stylus" scoped>
.icon-precedence
  margin-left: 10px;
  font-size: 18px;
  color: #f96630;
  cursor: pointer
</style>
